import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';

// components
import { BrowserModule } from "@angular/platform-browser";
import { InforitFilterMenuComponent } from "./inforit-filter-menu.component";

import { MatMenuModule as MatMenuModule } from "@angular/material/menu";
import { MatButtonModule as MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatFormFieldModule as MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule as MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule as MatCardModule } from "@angular/material/card";
import { MatDialogModule as MatDialogModule } from "@angular/material/dialog";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSelectModule as MatSelectModule } from "@angular/material/select";
import { MatRadioModule as MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule as MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatCheckboxModule as MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [
    MatMenuModule,
    CommonModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatToolbarModule,
    MatSidenavModule,
    FormsModule,
    MatSelectModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    TranslateModule,
  ],
  declarations: [InforitFilterMenuComponent],
  exports: [InforitFilterMenuComponent],
})
export class InforitLibraryModule {}
